import { api } from './client';

/**
 * Per ADR-0036 (goal_refinement_available), ADR-0037
 * (test_call_refinement_available) and ADR-0046 (session_goal_deviation).
 * Every kind is carried by the same envelope and clicked the same way —
 * the SPA's bell handler navigates to `actionUrl` and `kind` is
 * informational. Title/body are localised server-side so the topbar
 * renders them verbatim.
 */
export type NotificationKind =
  | 'goal_refinement_available'
  | 'test_call_refinement_available'
  | 'session_goal_deviation'
  | 'spend_cap_warning'
  | 'spend_cap_reached'
  | 'auto_topup_disabled'
  | 'site_fetch_completed'
  | 'site_fetch_failed';

export interface NotificationDto {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string;
  actionUrl: string;
  projectId: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface ListNotificationsResponse {
  count: number;
  notifications: NotificationDto[];
}

export async function listNotifications(
  opts: {
    onlyUnread?: boolean;
    limit?: number;
  } = {},
): Promise<ListNotificationsResponse> {
  const params: Record<string, string> = {};
  if (opts.onlyUnread) params.onlyUnread = 'true';
  if (opts.limit !== undefined) params.limit = String(opts.limit);
  const res = await api.get<ListNotificationsResponse>('/v1/notifications', { params });
  return res.data;
}

export async function getUnreadCount(): Promise<{ count: number }> {
  const res = await api.get<{ count: number }>('/v1/notifications/unread-count');
  return res.data;
}

export async function markRead(id: string): Promise<NotificationDto> {
  const res = await api.post<NotificationDto>(`/v1/notifications/${id}/read`);
  return res.data;
}
